// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes _1YxNl{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}@keyframes _1YxNl{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}._3FKge{margin-top:2.4rem}._3P1mj{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;gap:8px;gap:.8rem;margin-bottom:2.4rem}._2MsMH{height:18px;height:1.8rem;min-width:18px;min-width:1.8rem}._2lRUw{font-size:14px;font-size:1.4rem;font-weight:500;line-height:21px;line-height:2.1rem}", ""]);
// Exports
exports.locals = {
	"container": "_3FKge",
	"disclaimer": "_3P1mj",
	"disclaimer__icon": "_2MsMH",
	"disclaimer__text": "_2lRUw",
	"fading": "_1YxNl"
};
module.exports = exports;
